<template>
	<v-container>
		<v-card>
			<v-card-title class="d-flex align-center">
				<v-icon
					icon="$descriptions"
					start
				/>
				<translate>Claim Status Descriptions</translate>
			</v-card-title>
			<v-card-text>
				<model-backend-table
					:endpoint="`/api/v0/claimstatusdescriptions?claimstatus_id=${claimstatusId}&claim_type=${claimType}`"
					:headers="headers"
					:sort-by="[{key: sortBy, order: sortDesc}]"
				>
					<template #item.claimstatus="{ item }">
						<a :href="`/bo/claimstatusdescriptions/edit?id=${item.id}`">
							{{ item.claimstatus.name }}
						</a>
					</template>
					<template #item.claimType="{ value }">
						{{ claimTypes[value] }}
					</template>
					<template #item.language="{ value }">
						<v-img
							v-if="ifFile(value.iso6391 + '.svg')"
							:src="'/images/flags/' + value.iso6391 + '.svg'"
							:alt=" value.name "
							width="32px"
							height="24px"
						/>
						<div v-else>
							{{ value.name }}
						</div>
					</template>
					<template #item.domain="{ value }">
						{{ value.name }}
					</template>
					<template
						#item.remove="{ item }"
					>
						<confirm-button
							v-can="'claimstatusdescription.delete'"
							small
							color="error"
							:text="$gettext('Are you sure you want to delete this page?')"
							:callback="() => { deleteClaimStatusDescription(item.id); }"
						>
							<translate>Remove</translate>
						</confirm-button>
					</template>
					<template #bottom />
				</model-backend-table>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import ModelBackendTable from '../../../molecules/ModelBackendTable.vue';
import ConfirmButton from '../../../atoms/ConfirmButton.vue';
import axios from 'axios';
import {
	displayError, inform,
} from 'laravel-front-library';
export default {
	name: 'ClaimStatusDescriptionView',
	components: {
		ConfirmButton,
		ModelBackendTable
	},

	data () {
		return {
			claimstatusId: '',
			claimType: '',
			sortBy: null,
			sortDesc: true,
		};
	},

	computed: {
		headers () {
			const headers = [
				{
					title: 'id', align: 'start', sortable: true, value: 'id', filterable: false
				},
				{
					title: this.$gettext('Claim Status'), sortable: true, value: 'claimstatus', filterable: true
				},
				{
					title: this.$gettext('Claim Type'), sortable: true, value: 'claimType', filterable: true
				},
				{
					title: this.$gettext('Domain'), sortable: true, value: 'domain', filterable: true
				},
				{
					title: this.$gettext('Language'), sortable: true, value: 'language', filterable: true
				},
			];

			if(localStorage.getItem('permissions').includes('claimstatusdescription.delete')) {
				headers.push({
					text: this.$gettext('Remove'), sortable: true, value: 'remove', filterable: false
				});
			}
			return headers;
		},
		claimTypes () {
			return {
				'': this.$gettext('Both'),
				'damage': this.$gettext('Damage'),
				'loss': this.$gettext('Loss')
			};
		}
	},

	created () {
		const uri = window.location.search.substring(1);
		const params = new URLSearchParams(uri);

		if (params.get('claimstatus_id')) {
			this.claimstatusId = parseInt(params.get('claimstatus_id'));
		}
		if (params.get('claim_type')) {
			this.claimType = params.get('claim_type');
		}
	},

	methods: {
		/**
		 * Delete selected claimstatusdescription.
		 *
		 * @param {number} id - id of the claim status description that will be deleted.
		 * @returns {void}
		 */
		deleteClaimStatusDescription (id) {
			axios.delete('/api/v0/claimstatusdescriptions', {
				params: {
					id: id
				}
			}).then(() => {
				inform(this.$gettext('Description deleted.'));
				this.$refs.modelTable.index();
			}).catch(({
				response
			}) => {
				let message;

				if (response.data && response.data.message) {
					message = response.data.message;
				} else {
					message = this.$gettext('Something went wrong while deleting the description');
				}
				displayError(message);
			});
		},

		/**
		 * Checks if our language is a flag path or just text.
		 *
		 * @param {string} language - language the email template is.
		 * @returns {boolean} Whether it is a flag path or not
		 */
		ifFile (language) {
			return !!/(?:\.([^.]+))?$/.exec(language)[1];
		}
	}
};
</script>

